<script lang="ts">
    import { Link } from "svelte-routing";
    import { ROUTES } from "./routes"
</script>

<p>
    <Link to={ROUTES.HOME}>&lt;&lt;&nbsp;back</Link>
</p>

<h5 class="text-h5">Imprint</h5>

<p>
    <em>(German law demands this)</em>
</p>

<p>
    Paul Sturm<br>
    Pestalozzistr. 13 B<br>
    10625 Berlin
</p>

<p>
    website: etch-a-skratch.riel030.de
</p>
<p>
    email: etch-a-skratch (at) riel030 (dot) de
</p>
<p>
    phone: 49 172 390 65 24
</p>
